import { defineMessages } from "react-intl";

import {
	Result,
	resultMessages,
	validator
} from "lib/build/forms/ltx/phase-i/consultations/urology";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	urology: {
		id: "form.urology",
		defaultMessage: "Urológiai szakvizsgálat"
	},
	result: {
		id: "form.urology.result",
		defaultMessage: "Eltérés"
	},
	dre: {
		id: "form.urology.dre",
		defaultMessage: "Rectális digitális vizsgálat során eltérés"
	},
	psa: {
		id: "form.urology.psa",
		defaultMessage: "PSA vizsgálat során eltérés"
	},
	[Result.ABNORMAL]: {
		id: "form.urology.result.option.abnormal",
		defaultMessage: "Igen"
	},
	[Result.NORMAL]: {
		id: "form.urology.result.option.normal",
		defaultMessage: "Nem"
	}
});

const options = {
	result: [
		{ value: Result.ABNORMAL, label: messages[Result.ABNORMAL] },
		{ value: Result.NORMAL, label: messages[Result.NORMAL] }
	]
};

const fields: { [key: string]: FieldData } = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: resultMessages } }
	},
	dre: {
		type: "field",
		path: ["dre"],
		label: messages.dre,
		errorMessages: genericErrorMessages,
		input: {
			type: "measured-button-group",
			props: { options: options.result }
		}
	},
	psa: {
		type: "field",
		path: ["psa"],
		label: messages.psa,
		errorMessages: genericErrorMessages,
		input: {
			type: "measured-button-group",
			props: { options: options.result }
		}
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.result }] },
		{ columns: [{ width: 12, field: fields.dre }] },
		{ columns: [{ width: 12, field: fields.psa }] }
	]
};

export const node: LeafNode = {
	id: "urology",
	value: {
		title: messages.urology,
		validator,
		fieldset
	}
};
